<script>
import { getDocumentTypeId } from '@utils/transformations'

export default {
  name: 'FiltersDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Array,
      default: () => [],
    },
    modelName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      item: {},
      numberComparisonOptions: [
        { value: 'EQ', label: '=' },
        { value: 'GT', label: '>' },
        { value: 'LT', label: '<' },
        { value: 'NE', label: '≠' },
      ],
    }
  },
  computed: {
    fields() {
      return this.model.filter(elem => elem.type !== 'id')
    },
    hasType() {
      return (
        !!this.$route.params.documentType &&
        this.$route.params.documentType !== 'all'
      )
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  mounted() {
    if (this.hasType) {
      const docType = getDocumentTypeId(this.$route.params.documentType)
      this.item.type = docType
    }
    const filters = this.$store.state.filters.filters[this.modelName]
    if (filters) Object.assign(this.item, filters.item)
    if (this.model) {
      Object.keys(this.model)
        .filter(key => this.model[key].type === 'number')
        .forEach(key => {
          this.item[this.model[key].code] =
            this.model[key].default.comparison || 'EQ'
        })
    }
  },
  methods: {
    getDictionary(value) {
      if (value === 'devices') {
        const dict = this.$store.getters['data/getDictionary']('devices')
        return dict
          ? dict.filter(item => item.goodsGroup === 2 || item.goodsGroup === 5)
          : []
      }
      if (value === 'goodsgroup' && this.modelName === 'goods') {
        return this.$store.getters['data/getDictionary'](value)
          .filter(elem => elem.code !== 5)
          .map(item => {
            item.name = this.$t(`goodsgroup.${item.code}.name`)
            return item
          })
      }
      if (
        value === 'documenttype' ||
        value === 'documentstatus' ||
        value === 'goodsstatus' ||
        value === 'organizationstatus' ||
        value === 'organizationtype' ||
        value === 'deliverytype' ||
        value === 'userstatus' ||
        value === 'contactstatus' ||
        value === 'sex'
      ) {
        return this.$store.getters['data/getDictionary'](value).map(item => {
          const itemCopy = { ...item }
          itemCopy.name = this.$t(`${value}.${itemCopy.code}.name`)
          return itemCopy
        })
      }
      return this.$store.getters['data/getDictionary'](value)
    },
    clearFilters() {
      this.$refs.filterForm.reset()
      if (this.hasType) {
        const docType = getDocumentTypeId(this.$route.params.documentType)
        this.item.type = docType
      }
      if (this.model) {
        Object.keys(this.model)
          .filter(key => this.model[key].type === 'number')
          .forEach(key => {
            this.item[this.model[key].code] =
              this.model[key].default.comparison || 'equal'
          })
      }
      this.$store.commit('filters/CLEAR_FILTERS', this.modelName)
      this.$emit('filters-confirmed')
    },
    closeModal() {
      this.$emit('close-modal')
    },
    isNull(value) {
      return value === null || value === undefined || value === ''
    },
    submit() {
      const filters = {}
      for (const key of Object.keys(this.item)) {
        if (
          this.isNull(this.item[key]) &&
          key !== 'sex' &&
          key !== 'writeoff' &&
          key !== 'opened' &&
          key !== 'shipment' &&
          key !== 'offs'
        )
          continue
        const model = this.model.find(elem => elem.code === key)
        switch (model.type) {
          case 'select':
            filters[`filter_${key.toString()}_comparison`] = 'EQ'
            filters[`filter_${key}_value`] = this.item[key]
            break
          case 'input':
            if (model.isNumber || model.isUuid) {
              filters[`filter_${key.toString()}_comparison`] = 'EQ'
            } else {
              filters[`filter_${key.toString()}_comparison`] = 'LIKE'
            }
            filters[`filter_${key}_value`] = this.item[key]
            break
          case 'number':
            if (!this.isNull(model.itemValue)) {
              filters[`filter_${key.toString()}_comparison`] = this.item[key]
              filters[`filter_${key.toString()}_value`] = model.itemValue
            }
            break
          case 'checkbox':
            if (!this.item[key] || this.item[key] === false) {
              delete filters[`filter_${key.toString()}_value`]
              delete filters[`filter_${key.toString()}_comparison`]
            } else {
              filters[`filter_${key.toString()}_comparison`] = null
              filters[`filter_${key}_value`] = this.item[key]
            }
            break
          default:
            filters[`filter_${key.toString()}_comparison`] = null
            filters[`filter_${key}_value`] = this.item[key]
            break
        }
      }
      let i = {}
      Object.assign(i, this.item)
      this.$store.commit('filters/SET_FILTERS', {
        name: this.modelName,
        item: {
          item: i,
          value: filters,
        },
      })
      this.$emit('filters-confirmed')
    },
  },
}
</script>

<template>
  <keep-alive>
    <v-dialog
      v-model="visible"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <div class="headline">{{ $t('titles__filter') }}</div>
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-container
            fluid
            grid-list-md>
            <v-layout wrap>
              <v-flex
                xs12
                class="text-xs-center"
              >
                <v-form
                  ref="filterForm"
                  lazy-validation
                >
                  <template v-for="field in fields">
                    <v-text-field
                      v-if="field.type === 'input'"
                      :key="field.code"
                      :name="field.code"
                      :label="$t(`label__${field.name}`)"
                      v-model="item[field.code]"
                      :type="field.isNumber ? 'number' : 'text'"
                      autocomplete="off"
                    />
                    <v-select
                      v-if="field.type === 'select'"
                      :key="field.code"
                      :items="getDictionary(field.dictionary)"
                      :label="$t(`label__${field.name}`)"
                      v-model="item[field.code]"
                      :item-text="field.itemText"
                      :item-value="field.itemValue"
                      :disabled="field.code === 'type' && hasType"
                      :multiple="multiSelect"
                      clearable
                      autocomplete
                    />
                    <v-layout
                      v-if="field.type === 'number'"
                      :key="field.name"
                      row
                    >
                      <v-flex xs2>
                        <v-select
                          v-model="item[field.code]"
                          :items="numberComparisonOptions"
                          item-text="label"
                          item-value="value"
                        />
                      </v-flex>
                      <v-flex xs10>
                        <v-text-field
                          v-model.number="field.itemValue"
                          :label="$t(`label__${field.label}`)"
                          type="number"
                        />
                      </v-flex>
                    </v-layout>
                    <v-checkbox
                      v-if="field.type === 'checkbox'"
                      :key="field.code"
                      v-model="item[field.code]"
                      :label="$t(`label__${field.label}`)"
                      primary
                    />
                  </template>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click="closeModal">{{ $t('buttons__close') }}</v-btn>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click="clearFilters">{{ $t('buttons__clear_filters') }}</v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="primary"
            @click="submit">{{ $t('buttons__confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </keep-alive>
</template>
